import React from 'react';
import PropTypes from 'prop-types';

import AccountDropDown from 'components/nav/authenticated/AccountDropDown';
import AuthenticatedNavBottom from 'components/nav/authenticated/AuthenticatedNavBottom';
import AuthorAvatar from 'components/nav/authenticated/AuthorAvatar';
import MobileMenus from 'components/nav/authenticated/mobile';
import MobileMenuToggle from 'components/nav/shared/MobileMenuToggle';
import NavCollapsible from 'components/nav/shared/NavCollapsible';
import NavLogo from 'components/nav/shared/NavLogo';
import UtilityItems from 'components/nav/authenticated/UtilityItems';

class AuthenticatedNavBar extends React.Component {
  static propTypes = {
    currentIdentity: PropTypes.object.isRequired,
    identities: PropTypes.arrayOf(PropTypes.object).isRequired,
    isNavMenuOpen: PropTypes.bool.isRequired,
  };

  render() {
    const { currentIdentity, identities } = this.props;
    const name = currentIdentity ? currentIdentity.claimedAuthorName : '';
    return (
      <div>
        <nav className="aa-navbar-first navbar navbar-inverse navbar-static-top">
          <div className="container-fluid">
            <div>
              <MobileMenuToggle isNavMenuOpen={this.props.isNavMenuOpen} />
              <NavLogo />

              <div className="navbar-header pull-right hidden-sm hidden-md hidden-lg">
                <div className="aa-avatar-nav">
                  <AuthorAvatar authorName={name} amazonAuthorId={currentIdentity.amazonAuthorId} />
                </div>
              </div>

              {/* Mobile menu logic, xs screen size only */}
              <div className="remove-padding-xs hidden-sm hidden-md hidden-lg">
                <NavCollapsible
                  className="nav-left aa-nav-left"
                  menus={MobileMenus}
                  isNavMenuOpen={this.props.isNavMenuOpen}
                />
              </div>

              {/* Top nav bar right, all sizes but xs */}
              <div className="navbar-right hidden-xs">
                <UtilityItems />
                <ul className="nav navbar-nav">
                  <div className="aa-avatar-nav">
                    <AuthorAvatar
                      authorName={name}
                      amazonAuthorId={currentIdentity.amazonAuthorId}
                    />
                  </div>
                </ul>
                <ul className="nav navbar-nav">
                  <AccountDropDown identities={identities} />
                </ul>
              </div>
            </div>
          </div>
        </nav>
        <AuthenticatedNavBottom />
      </div>
    );
  }
}

export default AuthenticatedNavBar;
